import { useState } from "react";
import { X } from "@phosphor-icons/react";
import Logo from "assests/logo.png";
import { Link } from "react-router-dom";
import GetLinks from "Constant/Header/Header";
import { CaretDown, CaretUp } from "@phosphor-icons/react";

const DrawerModal = ({
  isVisible,
  onHandleDrawer,
  children,
  isDown,
  isSticky,
}) => {
  const links = GetLinks();
  const [openMegaIndex, setOpenMegaIndex] = useState(null); // To track which mega menu is open

  const handleClose = () => {
    setOpenMegaIndex(null); // Reset mega menu state
    onHandleDrawer(); // Close the drawer
  };

  const toggleMegaMenu = (index) => {
    // Toggle the current mega menu, close others
    if (openMegaIndex === index) {
      setOpenMegaIndex(null); // Collapse if already open
    } else {
      setOpenMegaIndex(index); // Open the clicked mega menu
    }
  };
  return (
    <>
      {/* Overlay */}
      <div
        className={`transition xsl:hidden ease-in duration-300 ${
          isVisible
            ? "translate-x-[0%] opacity-100"
            : "translate-x-[-100%] opacity-0"
        } fixed h-[200vh] w-[100vw] bg-[#000000ca] inset-0`}
        onClick={handleClose}
      ></div>

      {/* Drawer Content */}
      <div
        className={`xsl:hidden fixed ${
          isDown && !isSticky ? "mt-[10vh]" : "mt-0"
        } ${
          isSticky && isDown ? "mt-[0vh]" : "mb-0"
        }   transition ease-in duration-300 z-[10000000000000] ${
          isVisible
            ? "visible translate-x-[0%] right-0 top-0 bottom-0 bg-black shadow-2xl shadow-[#ffffff7f] min-h-[100vh] w-[80vw] lg:w-[50vw]"
            : "invisible translate-x-[100%]"
        }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-white">
          <Link onClick={handleClose} className="w-1/4" to={"/"}>
            <img src={Logo} alt="Logo" />
          </Link>
          <button
            onClick={handleClose}
            className="p-2 hover:bg-gray-800 rounded-full transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        {/* Content Section */}
        <ul className="flex flex-col capitalize p-4">
          {links?.map(({ name, path, mega, pages }, index) =>
            mega ? (
              <li key={index} className="text-lg border-b py-2 text-start">
                <button
                  onClick={() => toggleMegaMenu(index)}
                  className="w-full flex items-center justify-between hover:text-[#ccc]"
                >
                  {name}

                  {openMegaIndex === index ? (
                    <CaretUp size={20} />
                  ) : (
                    <CaretDown size={20} />
                  )}
                </button>

                {/* Collapsible content */}
                {openMegaIndex === index && (
                  <ul className="my-2 flex flex-col list-disc list-inside">
                    {pages.map(({ name, slug }, index) => (
                      <li key={index}>
                        <Link
                          className="text-base text-start hover:underline"
                          to={slug}
                          onClick={handleClose}
                        >
                          {name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ) : (
              <Link
                onClick={handleClose}
                className="text-lg border-b py-2 hover:text-[#ccc]"
                key={index}
                to={path}
              >
                {name}
              </Link>
            )
          )}
        </ul>
      </div>
    </>
  );
};

export default DrawerModal;
